import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {VisitConfigurationModel} from "../../../models/visit-configuration.model";
import {AccountModel} from "../../../../account/angular/models/account.model";

export const VisitConfigurationChannelActions = createActionGroup({
  source: '[VisitConfiguration/Channel]',
  events: {
    subscribe: emptyProps(),
    subscribePartial: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: VisitConfigurationModel }>(),
    partialNotificationReceived: props<{ notification: VisitConfigurationModel }>(),
  }
});

export const VisitConfigurationAPiActions = createActionGroup({
  source: '[VisitConfiguration/API]',
  events: {

    //Get infinite scroll
    getInfiniteScroll: props<{ params?: any }>(),
    getInfiniteScrollSuccess: props<{ visitConfigurations: VisitConfigurationModel[], cursor?: string }>(),
    getInfiniteScrollFailure: props<{ error: any }>(),

    //Get Many
    getMany: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getManySuccess: props<{ visitConfigurations: VisitConfigurationModel[], cursor?: string }>(),
    getManyFailure: props<{ error: any }>(),

    //Get One
    getOne: props<{ id: string, isSubscribeToChannel?: boolean }>(),
    getOneSuccess: props<{ visitConfiguration: VisitConfigurationModel, isSubscribeToChannel?: boolean }>(),
    getOneFailure: props<{ error: any }>(),

    //Create One
    createOne: props<{visitConfiguration: VisitConfigurationModel }>(),
    createOneSuccess: props<{ visitConfiguration: VisitConfigurationModel }>(),
    createOneFailure: props<{ error: any }>(),

    //Update One
    updateOne: props<{ id: string, visitConfiguration: VisitConfigurationModel }>(),
    updateOneSuccess: props<{ visitConfiguration: VisitConfigurationModel }>(),
    updateOneFailure: props<{ error: any }>(),

    //Delete One
    deleteOne: props<{ id: string }>(),
    deleteOneSuccess: props<{ id: string }>(),
    deleteOneFailure: props<{ error: any }>()

  },
});

export const VisitConfigurationActions = createActionGroup({
  source: '[VisitConfiguration]',
  events: {
    removeMany: props<{ ids: string[] }>(),
    removeOne: props<{ id: string }>(),
    setMany: props<{ visitConfigurations: VisitConfigurationModel[], isAppendFirst?: boolean }>(),
    setInfiniteScrollIds: props<{ ids: string[], isAppendFirst?: boolean }>(),
    setOne: props<{ visitConfiguration: VisitConfigurationModel, isAppendFirst?: boolean }>(),
    updateOne: props<{ visitConfiguration: VisitConfigurationModel }>(),
    updateMany: props<{ visitConfigurations: VisitConfigurationModel[] }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});

